function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { RateBox } from '../RateBox';
import { Alertbox, Flex, FocusHeader, Tabs, Tab, Text } from '@olxbr/ds-web';
import { AlertBoxWrapper, CloseButton, CardsContainer, ModalBackdrop, ModalContainer } from './styles';
import Card from '../Card';
import { clickAlertBoxSecurityModal, clickChangeTab } from '../../helpers/lurker';
import { parseHTML } from '../../helpers/parseHTML';
export function SecurityCentralModal(_ref) {
  var isMobile = _ref.isMobile,
    isOpen = _ref.isOpen,
    handleCloseModal = _ref.handleCloseModal,
    idPage = _ref.idPage,
    variant = _ref.variant;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasAlertBoxMessage = _useState4[0],
    setHasAlertBoxMessage = _useState4[1];
  useEffect(function () {
    if (isOpen) {
      fetch("https://s3.amazonaws.com/static.olx.com.br/chat-moderation/security-central/".concat(idPage, "_").concat(variant, ".json")).then(function (response) {
        if (response.ok) {
          return response.json();
        }
        throw response;
      }).then(function (apiData) {
        if (apiData !== null && apiData !== void 0 && apiData.alertMessage.hasOwnProperty('description')) {
          setHasAlertBoxMessage(true);
        }
        setData(apiData);
      })["catch"](function (error) {
        return console.error('Erro na solicitação à API', error);
      });
    }
  }, [isOpen, variant]);
  var handleScroll = function handleScroll(e) {
    e.stopPropagation();
  };
  var handleClickAlertBox = function handleClickAlertBox() {
    clickAlertBoxSecurityModal({
      idPage: idPage,
      variant: variant
    });
  };
  if (!isOpen || (data === null || Object.keys(data).length === 0) && isOpen) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalBackdrop, {
    onClick: handleCloseModal
  }), /*#__PURE__*/React.createElement(ModalContainer, {
    isMobile: isMobile,
    onWheel: handleScroll
  }, isMobile ? /*#__PURE__*/React.createElement(FocusHeader, {
    title: data.titlePage,
    hideLogo: true,
    goBack: handleCloseModal
  }) : /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "--spacing-1"
  }, /*#__PURE__*/React.createElement(Text.SubtitleLarge, null, data.titlePage), /*#__PURE__*/React.createElement(CloseButton, {
    onClick: handleCloseModal
  }, /*#__PURE__*/React.createElement(Text.SubtitleLarge, null, "x"))), hasAlertBoxMessage && /*#__PURE__*/React.createElement(AlertBoxWrapper, {
    isMobile: isMobile
  }, /*#__PURE__*/React.createElement(Alertbox, {
    title: data.alertMessage.title,
    variant: data.alertMessage.variant
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    onClick: handleClickAlertBox
  }, parseHTML(data.alertMessage.description)))), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "--spacing-1-5"
  }, /*#__PURE__*/React.createElement(Tabs, {
    justifyContent: "space-between",
    alignItems: "center",
    onChange: function onChange(tabId) {
      return clickChangeTab(tabId, idPage);
    }
  }, data.tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(Tab, {
      key: tab.id,
      id: tab.id,
      label: isMobile ? tab.nameMobile : tab.name
    }, /*#__PURE__*/React.createElement(CardsContainer, null, tab.cards.map(function (card) {
      return /*#__PURE__*/React.createElement(Card, {
        key: card.id,
        content: card,
        isMobile: isMobile,
        idPage: idPage
      });
    }), /*#__PURE__*/React.createElement(RateBox, {
      lurkerObjName: "".concat(idPage, "_rate_box"),
      luckerDetail: "security_central_modal",
      idLocalStorage: "".concat(idPage, "_").concat(tab.id),
      isMobile: isMobile,
      chatId: "".concat(idPage, "-").concat(variant)
    })));
  }))))), document.body));
}
SecurityCentralModal.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  idPage: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired
};
export default SecurityCentralModal;